import React from 'react';
import Icon from 'components/AppIcon';

const TEMPLATES = {
  Conservative: {
    icon: 'Shield',
    color: '#10B981',
    description: 'Maximize savings, minimize discretionary spending',
    allocations: {
      Rent: 0.30,
      Groceries: 0.15,
      Transportation: 0.10,
      Healthcare: 0.08,
      Utilities: 0.07,
      Entertainment: 0.05,
      Dining: 0.05,
      Shopping: 0.05,
      Other: 0.05,
      Savings: 0.10,
    },
  },
  Balanced: {
    icon: 'Scale',
    color: '#00E5FF',
    description: 'Balanced lifestyle with moderate savings',
    allocations: {
      Rent: 0.28,
      Groceries: 0.12,
      Transportation: 0.10,
      Entertainment: 0.08,
      Dining: 0.08,
      Shopping: 0.08,
      Healthcare: 0.06,
      Other: 0.10,
      Savings: 0.10,
    },
  },
  Aggressive: {
    icon: 'Zap',
    color: '#7B2FBE',
    description: 'High income, lifestyle-focused spending',
    allocations: {
      Rent: 0.25,
      Groceries: 0.10,
      Transportation: 0.10,
      Entertainment: 0.12,
      Dining: 0.12,
      Shopping: 0.12,
      Healthcare: 0.05,
      Other: 0.14,
    },
  },
};

export default function BudgetTemplates({ totalBudget, onApply }) {
  return (
    <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(0,229,255,0.1)] rounded-xl p-4">
      <h3 className="text-[#E2E8F0] font-semibold text-sm mb-3 flex items-center gap-2">
        <Icon name="Wand2" size={16} color="#00E5FF" />
        Quick Templates
      </h3>
      <div className="grid grid-cols-3 gap-3">
        {Object.entries(TEMPLATES)?.map(([name, tmpl]) => (
          <button
            key={name}
            onClick={() => {
              const applied = {};
              Object.entries(tmpl?.allocations)?.forEach(([cat, pct]) => {
                applied[cat] = Math.round(totalBudget * pct);
              });
              onApply(applied);
            }}
            className="flex flex-col items-center gap-2 p-3 rounded-xl border border-[rgba(255,255,255,0.08)] hover:border-opacity-40 transition-all duration-200 group"
            style={{ borderColor: `${tmpl?.color}20` }}
          >
            <div className="w-10 h-10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform" style={{ backgroundColor: `${tmpl?.color}20` }}>
              <Icon name={tmpl?.icon} size={20} color={tmpl?.color} />
            </div>
            <span className="text-xs font-semibold" style={{ color: tmpl?.color }}>{name}</span>
            <span className="text-[10px] text-[#64748B] text-center leading-tight">{tmpl?.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
